import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-individual-entity',
  templateUrl: './individual-entity.component.html',
  styleUrls: ['./individual-entity.component.css']
})
export class IndividualEntityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
